var Action = /*#__PURE__*/function (Action) {
  Action["TOUT"] = "TOUT";
  Action["CREATION"] = "CREATION";
  Action["MODIFICATION"] = "MODIFICATION";
  Action["SUPPRESSION"] = "SUPPRESSION";
  Action["VOIR"] = "VOIR";
  Action["AUCUN"] = "AUCUN";
  return Action;
}(Action || {});
export default Action;